// extracted by mini-css-extract-plugin
module.exports = {"OrgCategoryListWrap":"OrgCategoryList_OrgCategoryListWrap__2yEX5"};